import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/ContactForm.css';

const VILLAGE_OPTIONS = [
    { value: 'Norabac', label: 'Նորաբաց' },
    { value: 'Nerkin Charbakh', label: 'Ներքին Չարբախ' },
    { value: 'Darakert', label: 'Դարակերտ' },
    { value: 'Dashtavan', label: 'Դաշտավան' },
];

export default function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        village: '',
        address: '',
        message: '',
    });
    const [errors, setErrors] = useState({});
    const [statusMessage, setStatusMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: undefined }));
    };

    const validate = () => {
        const errs = {};

        // Name validation
        if (!formData.name.trim()) {
            errs.name = 'Անունը պարտադիր է։';
        } else if (!/^[A-Za-zԱ-Ֆա-ֆ\s]{2,50}$/.test(formData.name.trim())) {
            errs.name = 'Անունը պետք է պարունակի միայն տառեր և լինի առնվազն 2 նիշ։';
        }

        // Phone validation
        if (!formData.phone.trim()) {
            errs.phone = 'Հեռախոսահամարը պարտադիր է։';
        } else if (!/^(\+374\d{8}|0\d{8}|\+7\d{10}|8\d{10})$/.test(formData.phone.trim())) {
            errs.phone = 'Մուտքագրեք վավեր հեռախոսահամար՝ օրինակ +37499111222։';
        }

        // Email
        if (formData.email) {
            if (!/^[\w.-]+@[\w.-]+\.(com|am|org|net)$/.test(formData.email)) {
                errs.email = "Էլ. հասցեն պետք է '.com', '.am' և այլն վերջավորությամբ։";
            }
        }

        // Village
        if (!formData.village) {
            errs.village = 'Խնդրում ենք ընտրել գյուղը։';
        }

        // Address
        // if (!formData.address) {
        //     errs.address = 'Հասցեն պարտադիր է։';
        // } else if (formData.address.length < 5) {
        //     errs.address = 'Հասցեն պետք է ունենա առնվազն 5 նիշ։';
        // } else if (!/\W/.test(formData.address)) {
        //     errs.address = 'Խնդրում ենք մանրամասն նշել հասցեն՝ փողոց, թիվ և այլն։';
        // }

        // Message
        if (formData.message) {
            if (formData.message.trim().length < 10) {
                errs.message = 'Հաղորդագրությունը պետք է ունենա առնվազն 10 նիշ։';
            } else if (/https?:\/\//.test(formData.message)) {
                errs.message = 'Խնդրում ենք չավելացնել հղումներ հաղորդագրության մեջ։';
            }
        }

        return errs;
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setSubmitting(true);
        setStatusMessage('');

        try {
            await axios.post('https://narek3303.pythonanywhere.com/landing/contact/', formData);
            // await axios.post('http://120.0.0.1:8000/landing/contact/', formData);
            setStatusMessage('Հաղորդագրությունը հաջողությամբ ուղարկվել է։');
            setFormData({ name: '', phone: '', email: '', village: '', address: '', message: '' });
        } catch (error) {
            if (error.response && error.response.data) {
                setErrors(error.response.data);
            } else {
                setStatusMessage('Սխալ տեղի ունեցավ։ Խնդրում ենք փորձել կրկին։');
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section id="contact" >
        <div className={`contact-container ${isVisible ? 'visible' : ''}`}>


            {/* Form */}
            <form onSubmit={handleSubmit} className="contact-form">
                <h2 className="form-title">Կապ մեզ հետ</h2>
                <p className="form-subtitle">Լրացրեք ձեր տվյալները, և մենք կապ կհաստատենք ձեզ հետ</p>

                {statusMessage && (
                    <div className={`status-message ${statusMessage.includes('հաջողությամբ') ? 'success' : 'error'}`}>
                        {statusMessage}
                    </div>
                )}

                <div className="form-grid">
                    {/* Name */}
                    <div className="form-group">
                        <label htmlFor="name" className="form-label">
                            <span className="label-text">Անուն</span>
                            <span className="required-indicator">*</span>
                        </label>
                        <div className="input-container">
                            <input
                                type="text"
                                name="name"
                                id="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`form-input ${errors.name ? 'error' : ''}`}
                                disabled={submitting}
                                placeholder="Մուտքագրեք ձեր անունը"
                            />
                            <div className="input-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                            </div>
                        </div>
                        {errors.name && <p className="form-error">{errors.name}</p>}
                    </div>

                    {/* Phone */}
                    <div className="form-group">
                        <label htmlFor="phone" className="form-label">
                            <span className="label-text">Հեռախոսահամար</span>
                            <span className="required-indicator">*</span>
                        </label>
                        <div className="input-container">
                            <input
                                type="text"
                                name="phone"
                                id="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className={`form-input ${errors.phone ? 'error' : ''}`}
                                disabled={submitting}
                                placeholder="+374 XX XXX XXX"
                            />
                            <div className="input-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                </svg>
                            </div>
                        </div>
                        {errors.phone && <p className="form-error">{errors.phone}</p>}
                    </div>

                    {/* Email */}
                    <div className="form-group">
                        <label htmlFor="email" className="form-label">
                            <span className="label-text">Էլ. հասցե <span className="text-gray-500 text-sm">(պարտադիր չէ)</span></span>
                        </label>
                        <div className="input-container">
                            <input
                                type="email"
                                name="email"
                                id="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`form-input ${errors.email ? 'error' : ''}`}
                                disabled={submitting}
                                placeholder="ձեր@էլ.հասցե.com"
                            />
                            <div className="input-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                </svg>
                            </div>
                        </div>
                        {errors.email && <p className="form-error">{errors.email}</p>}
                    </div>

                    {/* Village */}
                    <div className="form-group">
                        <label htmlFor="village" className="form-label">
                            <span className="label-text">Գյուղ</span>
                            <span className="required-indicator">*</span>
                        </label>
                        <div className="input-container">
                            <select
                                name="village"
                                id="village"
                                value={formData.village}
                                onChange={handleChange}
                                className={`form-input ${errors.village ? 'error' : ''}`}
                                disabled={submitting}
                            >
                                <option value="">Ընտրեք գյուղը</option>
                                {VILLAGE_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            <div className="input-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                    <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                            </div>
                        </div>
                        {errors.village && <p className="form-error">{errors.village}</p>}
                    </div>

                    {/* Address */}
                    {/*<div className="form-group">*/}
                    {/*    <label htmlFor="address" className="form-label">*/}
                    {/*        <span className="label-text">Հասցե</span>*/}
                    {/*        <span className="required-indicator">*</span>*/}
                    {/*    </label>*/}
                    {/*    <div className="input-container">*/}
                    {/*        <input*/}
                    {/*            type="text"*/}
                    {/*            name="address"*/}
                    {/*            id="address"*/}
                    {/*            value={formData.address}*/}
                    {/*            onChange={handleChange}*/}
                    {/*            className={`form-input ${errors.address ? 'error' : ''}`}*/}
                    {/*            disabled={submitting}*/}
                    {/*            placeholder="Մանրամասն հասցե"*/}
                    {/*        />*/}
                    {/*        <div className="input-icon">*/}
                    {/*            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">*/}
                    {/*                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>*/}
                    {/*                <circle cx="12" cy="10" r="3"></circle>*/}
                    {/*            </svg>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    {errors.address && <p className="form-error">{errors.address}</p>}*/}
                    {/*</div>*/}

                    {/* Message */}
                    <div className="form-group full-width">
                        <label htmlFor="message" className="form-label">
                            <span className="label-text">Հաղորդագրություն <span className="text-gray-500 text-sm">(պարտադիր չէ)</span></span>
                            {/*<span className="required-indicator">*</span>*/}
                        </label>
                        <div className="input-container">
                            <textarea
                                name="message"
                                id="message"
                                rows="4"
                                value={formData.message}
                                onChange={handleChange}
                                className={`form-input ${errors.message ? 'error' : ''}`}
                                disabled={submitting}
                                placeholder="Ձեր հաղորդագրությունը..."
                            />
                            <div className="input-icon textarea-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                </svg>
                            </div>
                        </div>
                        {errors.message && <p className="form-error">{errors.message}</p>}
                    </div>
                </div>

                <button
                    type="submit"
                    disabled={submitting}
                    className="submit-button"
                >
                    <span className="button-text">{submitting ? 'Ուղարկվում է...' : 'Ուղարկել հաղորդագրությունը'}</span>
                    <span className="button-icon">
                        {submitting ? (
                            <svg className="animate-spin" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="22" y1="2" x2="11" y2="13"></line>
                                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                            </svg>
                        )}
                    </span>
                </button>
            </form>

            {/* Sidebar */}
            <aside className="contact-sidebar">
                <div className="sidebar-content">
                    <h3 className="sidebar-title">Կապի տվյալներ</h3>
                    <p className="sidebar-description">Մենք պատրաստ ենք պատասխանել ձեր բոլոր հարցերին</p>

                    <div className="contact-info">
                        <div className="contact-item">
                            <div className="contact-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                </svg>
                            </div>
                            <div className="contact-details">
                                <h4>Հեռախոսահամար</h4>
                                <p>+374 77 003838</p>
                                <p className="contact-note">Պաշտոնական աջակցության համար զանգահարեք գործառնական ժամերին</p>
                            </div>
                        </div>

                        <div className="contact-item">
                            <div className="contact-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                </svg>
                            </div>
                            <div className="contact-details">
                                <h4>Էլեկտրոնային հասցե</h4>
                                <p>i-com.LLC@gmail.com</p>
                                <p className="contact-note">Պատասխանում ենք բոլոր նամակներին 24 ժամվա ընթացքում</p>
                            </div>
                        </div>

                        <div className="contact-item">
                            <div className="contact-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                    <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                            </div>
                            <div className="contact-details">
                                <h4>Գտնվելու վայր</h4>
                                <p>Ներքին Չարբախ, առաջին փողոց 2/2</p>

                            </div>
                        </div>
                    </div>


                </div>
            </aside>
        </div>
        </section>
    );
}
